import {
  shouldShowStep as shouldShowStepHelper,
  findNextVisibleQuestion as findNextVisibleQuestionHelper,
  isStepGatedByPlan,
} from '../components/chat/utils/chatFlowHelpers'

const useChatFlowHelpers = ({
  questions,
  questionGates,
  canAccess,
  getAnswersMap,
}) => {
  const shouldShowStep = (
    step,
    answersMap = getAnswersMap(),
  ) => {
    return shouldShowStepHelper({
      step,
      answersMap,
    })
  }

  const isQuestionGated = (index) => {
    return isStepGatedByPlan({
      step: questions[index],
      questionGates,
      canAccess,
    })
  }

  const findNextVisibleQuestion = (
    fromIndex,
    answersMap = getAnswersMap(),
  ) => {
    return findNextVisibleQuestionHelper({
      questions,
      fromIndex,
      answersMap,
      isQuestionGated,
    })
  }

  return {
    shouldShowStep,
    isQuestionGated,
    findNextVisibleQuestion,
  }
}

export default useChatFlowHelpers